import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Shown when an authenticated member hits a management route they lack the
 * permission for (the `requirePerm` gate in ProtectedRoute redirects here).
 */
const AccessDeniedPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-background-primary flex items-center justify-center p-6">
      <div className="max-w-md text-center space-y-4">
        <div className="text-6xl">🔒</div>
        <h1 className="text-2xl font-bold text-text-primary">Access Denied</h1>
        <p className="text-sm text-text-secondary">
          You don&apos;t have permission to view this page. If you think this is a mistake, reach
          out to your workspace admin.
        </p>
        <Link
          to="/learn/dashboard"
          className="inline-block px-6 py-2.5 bg-primary-500 hover:bg-primary-600 dark:hover:bg-primary-400 text-sm font-bold rounded-lg transition-colors"
        >
          Back to dashboard
        </Link>
      </div>
    </div>
  );
};

export default AccessDeniedPage;
